<template>

</template>

<script>
    import VisCommon from '../../components/VisCommon'

    export default {
      name: 'ScenarioCommon',
      extends: VisCommon,
      methods: {
        setScenario(value) {
          this.scenario = value
          if (this.scenario.id) {
            this.scenario.isSaved = true
          }
          this.setScenarioExtend(value)
        },
        setScenarioExtend() {

        },
        generateWords(answer) {
          let words = answer.words || answer.variants || ''
          if (typeof words === 'string' || words instanceof String) {
            if (words.length && words.indexOf('(') < 0) {
              words = '(' + words + ')'
            }
            return words
          } else if (Array.isArray(words)) {
            return '(' + words.join(', ') + ')'
          }
        },
        wordsEditorClass(words) {
          return (!words || !words.length) ? 'empty' : 'filled'
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ScenarioCommon.vue?6db69c6a